import type React from "react";
import { useTranslation } from "react-i18next";
import { ArrowUpLeft, ArrowUpRight } from "lucide-react";

const AddInLoginCallback: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div>
      <ArrowUpLeft className="text-primary absolute left-4 h-12 w-12" />
      <ArrowUpRight className="text-primary absolute right-4 h-12 w-12" />

      <div className="flex flex-col items-center justify-center p-6">
        <h1 className="text-2xl font-bold">
          {t(($) => $.commons.addIn.login.title)}
        </h1>
        <p className="text-sm">
          {t(($) => $.commons.addIn.login.successMessage)}
        </p>
        <p className="py-4 text-lg">
          {t(($) => $.commons.addIn.login.instructions)}
        </p>
      </div>
    </div>
  );
};

export default AddInLoginCallback;
